import React, { useState, useEffect } from 'react';
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import imgslide1 from "../Assets/carousel/C1.png";
import imgslide2 from "../Assets/carousel/C2.png";
import imgslide6 from "../Assets/carousel/C6.png";
import imgslide7 from "../Assets/carousel/C7.png";
import imgslide3 from "../Assets/carousel/C3.png";
import imgslide4 from "../Assets/carousel/C4.png";
import imgslide5 from "../Assets/carousel/C5.png";
import imgslide8 from "../Assets/carousel/C8.png";
import './SlicedSlider.css';

const SlicedSlider = () => {
  const [showFullImage, setShowFullImage] = useState(false);
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const numSlides = 15;
  const images = [imgslide3, imgslide4, imgslide5, imgslide1, imgslide2, imgslide6, imgslide7, imgslide8];

  // Update image at intervals
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setAnimationCompleted(false);
      setShowFullImage(false);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (animationCompleted) {
      setTimeout(() => {
        setShowFullImage(true);
      }, 500);
    }
  }, [animationCompleted]);

  const handleAnimationEnd = () => {
    setAnimationCompleted(true);
  };

  const getTransitionEffect = (index) => {
    switch (index) {
      case 1:
        return 'vortex-in';
      case 2:
        return 'flip-h-in';
      case 3:
        return 'power-on';
      case 4:
        return 'zoom-in';
      case 5:
        return 'flip-v-in';
      default:
        return '';
    }
  };

  const getBackgroundPosition = (index) => {
    if (window.innerWidth <= 768) {
      return `-${index * 50}px 0`;
    } else {
      return `-${index * 120}px 0`;
    }
  };

  // Navigation functions for arrows
  const handlePrevSlide = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    setAnimationCompleted(false);
    setShowFullImage(false);
  };

  const handleNextSlide = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    setAnimationCompleted(false);
    setShowFullImage(false);
  };

  return (
    <div className="sliderwrapper">
      <div className="wrapperrr">
        {!showFullImage ? (
          [...Array(numSlides)].map((_, index) => (
            <div
              key={index}
              className={`wrapperimgS ${getTransitionEffect(currentImageIndex)} ${animationCompleted ? 'hide' : ''}`}
              style={{
                backgroundImage: `url(${images[currentImageIndex]})`,
                backgroundPosition: getBackgroundPosition(index),
                animationDelay: `${index * 0.1}s`,
              }}
              onAnimationEnd={handleAnimationEnd}
            ></div>
          ))
        ) : (
          <div
            className="fullImage"
            style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
          ></div>
        )}
      </div>

      {/* Left and Right Arrow Buttons */}
      <button className="arrow-btn left rounded-[50%] " onClick={handlePrevSlide}><FaArrowLeft /></button>
      <button className="arrow-btn right rounded-[50%]" onClick={handleNextSlide}><FaArrowRight /></button>
    </div>
  );
};

export default SlicedSlider;
